import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Form, Modal } from 'antd';

import SubareaForm from '../SubareaForm';
import { useCreateSubArea } from '@/core/domain/operational/SubAreas/SubAreas.hooks';

type Props = {
  visible: boolean;
  handleVisible: () => void;
};

const CreateSubareaModal = ({ visible, handleVisible }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { areaId } = useRouteMatch<{ areaId: string }>().params;

  const createSubArea = useCreateSubArea();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        executionOrder: 0, // TODO: Remover obrigatoriedade do campo no endpoint
        areaId,
      };

      await createSubArea.mutateAsync(obj);

      handleCancel();
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'areas.subareas.create' })}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={createSubArea.isLoading}
    >
      <SubareaForm form={form} />
    </Modal>
  );
};

export default CreateSubareaModal;
